$(() => {
    $('#pageHeader-toggle').on('click', () => {
        let header = $('#pageHeader');
        let toggleClass = 'isActive';

        header.toggleClass(toggleClass)
    });

    $('#pageNavigation a').on('click', () => {
        let header = $('#pageHeader');
        let toggleClass = 'isActive';

        header.removeClass(toggleClass)
    });
});